<template>
	<v-row no-gutters ref="segment" v-if="show">
		<div v-if="showLeft" style="width: 50px">
			<v-icon
				@click="setLeftPositive"
				:color="test.left.result == true ? 'red' : 'grey lighten-1'"
			>mdi-plus-circle</v-icon>
			<v-icon
				@click="setLeftNegative"
				:color="test.left.result == false ? 'black' : 'grey lighten-1'"
			>mdi-minus-circle</v-icon>
		</div>
		<v-col class="text-truncate px-1">
			<span
				style="cursor:pointer"
				:class="test.left.note != '' || test.right.note != '' ? 'font-weight-bold' : ''"
				@click="showDetails = true"
			>{{test.short_name}}</span>
		</v-col>
		<div v-if="showRight" style="width: 50px">
			<v-icon
				@click="setRightPositive"
				:color="test.right.result == true ? 'green' : 'grey lighten-1'"
			>mdi-plus-circle</v-icon>
			<v-icon
				@click="setRightNegative"
				:color="test.right.result == false ? 'red' : 'grey lighten-1'"
			>mdi-minus-circle</v-icon>
		</div>
		<v-dialog v-model="showDetails" max-width="40%">
			<v-card>
				<v-card-title class="title primary--text secondary">{{name}}</v-card-title>
				<v-card-text class="pa-5">
					<v-textarea
						v-if="showLeft"
						v-model="test.left.note"
						:label="$gettext('Left')"
						outlined
						hide-details
						class="mb-5"
						:disabled="results"
					/>
					<v-textarea
						v-if="showRight"
						v-model="test.right.note"
						:label="$gettext('Right')"
						outlined
						hide-details
						:disabled="results"
					/>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showDetails = false">
						<translate>Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
export default {
	name: "BilateralSegmentTest",
	props: ["name", "showLeft", "showRight", "test", "results"],
	data: () => ({
		showDetails: false
	}),
	computed: {
		show() {
			if (!this.results) return true;
			else {
				if (this.test.left.result == null && this.test.right.result == null)
					return false;
				else return true;
			}
		}
	},
	methods: {
		setLeftPositive() {
			if (!this.results) {
				if (this.test.left.result == true) this.test.left.result = null;
				else this.test.left.result = true;
			}
		},
		setLeftNegative() {
			if (!this.results) {
				if (this.test.left.result == false) this.test.left.result = null;
				else this.test.left.result = false;
			}
		},
		setRightPositive() {
			if (!this.results) {
				if (this.test.right.result == true) this.test.right.result = null;
				else this.test.right.result = true;
			}
		},
		setRightNegative() {
			if (!this.results) {
				if (this.test.right.result == false) this.test.right.result = null;
				else this.test.right.result = false;
			}
		}
	}
};
</script>